export const commonAR = {
    items: [
        {
            name: "قائمة الاعمال",
            url: "/ToDo/myToDo"
        },
        {
            name: "الاعدادات",
            url:"/Settings"
        },
        // {
        //     name: "المنشورات",
        //     url:"/AllPosts"
        // }
    ]
}

export const commonEN = {
    items: [
        {
            name: "ToDo List",
            url: "/ToDo/myToDo"
        },
        {
            name: "Settings",
            url:"/Settings"
        },
        // {
        //     name: "Posts",
        //     url:"/AllPosts"
        // }
    ]
}
